export class UIManager {
  constructor(devtools) {
    this.devtools = devtools;
    this.styleSheet = null;
  }

  init() {
    this.injectStyles();
  }

  injectStyles() {
    const style = document.createElement('style');
    style.textContent = `
      .devtools-window {
        position: fixed;
        background: rgba(0, 0, 0, 0.9);
        border: 1px solid #333;
        border-radius: 4px;
        color: #00ff00;
        font-family: 'Courier New', monospace;
        font-size: 12px;
        z-index: 999999;
        min-width: 400px;
        max-width: 800px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
        image-rendering: pixelated;
        image-rendering: -moz-crisp-edges;
        image-rendering: crisp-edges;
      }

      .devtools-header {
        background: #1a1a1a;
        padding: 8px 12px;
        border-bottom: 1px solid #333;
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: move;
      }

      .devtools-title {
        color: #ff6b6b;
        font-weight: bold;
        text-shadow: 1px 1px 0px #000;
      }

      .devtools-controls {
        display: flex;
        gap: 8px;
      }

      .devtools-btn {
        background: #333;
        border: 1px solid #555;
        color: #fff;
        padding: 2px 8px;
        cursor: pointer;
        font-size: 10px;
        border-radius: 2px;
      }

      .devtools-btn:hover {
        background: #555;
      }

      .devtools-content {
        padding: 12px;
        max-height: 400px;
        overflow-y: auto;
      }

      .devtools-code {
        background: #0a0a0a;
        border: 1px solid #333;
        padding: 8px;
        margin: 8px 0;
        white-space: pre-wrap;
        font-family: 'Courier New', monospace;
        border-radius: 2px;
      }

      .devtools-error-line {
        background: rgba(255, 0, 0, 0.2);
        border-left: 3px solid #ff0000;
        padding-left: 8px;
      }

      .devtools-timestamp {
        color: #888;
        font-size: 10px;
      }

      .devtools-expandable {
        cursor: pointer;
        user-select: none;
      }

      .devtools-expandable:before {
        content: '▶ ';
        display: inline-block;
        transition: transform 0.2s;
      }

      .devtools-expandable.expanded:before {
        transform: rotate(90deg);
      }

      .devtools-collapsed {
        display: none;
      }

      /* Table Styles */
      .devtools-table {
        width: 100%;
        border-collapse: collapse;
        margin: 8px 0;
      }

      .devtools-table-header {
        display: flex;
        background: #2a2a2a;
        border-bottom: 2px solid #444;
        font-weight: bold;
      }

      .devtools-table-body {
        max-height: 300px;
        overflow-y: auto;
      }

      .devtools-table-row {
        display: flex;
        border-bottom: 1px solid #333;
        transition: background 0.2s;
      }

      .devtools-table-row:hover {
        background: rgba(255, 255, 255, 0.05);
      }

      .devtools-table-row.even {
        background: rgba(255, 255, 255, 0.02);
      }

      .devtools-table-cell {
        padding: 6px 8px;
        border-right: 1px solid #333;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .header-cell {
        cursor: pointer;
        user-select: none;
      }

      .header-cell:hover {
        background: rgba(255, 255, 255, 0.1);
      }

      .severity-cell {
        text-align: center;
        font-size: 16px;
      }

      .time-cell {
        font-size: 10px;
        color: #888;
      }

      .type-cell {
        font-weight: bold;
        color: #4fc3f7;
      }

      .message-cell {
        flex: 1;
        color: #ff6b6b;
      }

      .source-cell {
        color: #ffa500;
        font-size: 10px;
      }

      .actions-cell {
        display: flex;
        gap: 4px;
      }

      .devtools-btn-small {
        background: #444;
        border: 1px solid #666;
        color: #fff;
        padding: 2px 6px;
        cursor: pointer;
        font-size: 10px;
        border-radius: 2px;
      }

      .devtools-btn-small:hover {
        background: #666;
      }

      /* Analysis Styles */
      .devtools-analysis-section {
        margin: 12px 0;
        border: 1px solid #444;
        border-radius: 4px;
      }

      .devtools-section-header {
        background: #2a2a2a;
        padding: 8px 12px;
        font-weight: bold;
        color: #4fc3f7;
        border-bottom: 1px solid #444;
      }

      .devtools-section-header.expandable {
        cursor: pointer;
        user-select: none;
      }

      .devtools-section-header.expandable:hover {
        background: #333;
      }

      .devtools-section-content {
        padding: 8px 12px;
      }

      .devtools-section-content.collapsed {
        display: none;
      }

      .devtools-info-row {
        margin: 4px 0;
      }

      .devtools-info-row .label {
        color: #888;
        font-weight: bold;
      }

      .devtools-info-row .value {
        color: #fff;
      }

      /* Cause Items */
      .devtools-cause-item {
        margin: 8px 0;
        padding: 8px;
        background: rgba(255, 107, 107, 0.1);
        border-left: 3px solid #ff6b6b;
        border-radius: 2px;
      }

      .cause-header {
        display: flex;
        justify-content: space-between;
        margin-bottom: 4px;
      }

      .cause-type {
        font-weight: bold;
        color: #ff6b6b;
      }

      .cause-likelihood {
        font-size: 10px;
        color: #ffa500;
      }

      .cause-description {
        margin: 4px 0;
        color: #ccc;
      }

      .cause-fixes ul {
        margin: 4px 0;
        padding-left: 16px;
      }

      .cause-fixes li {
        margin: 2px 0;
        color: #4fc3f7;
      }

      /* Suggestion Items */
      .devtools-suggestion-item {
        margin: 8px 0;
        padding: 8px;
        background: rgba(79, 195, 247, 0.1);
        border-left: 3px solid #4fc3f7;
        border-radius: 2px;
      }

      .suggestion-header {
        display: flex;
        justify-content: space-between;
        margin-bottom: 4px;
      }

      .suggestion-title {
        font-weight: bold;
        color: #4fc3f7;
      }

      .suggestion-priority {
        font-size: 10px;
        padding: 2px 6px;
        border-radius: 2px;
      }

      .priority-critical {
        background: #ff0000;
        color: #fff;
      }

      .priority-high {
        background: #ff6600;
        color: #fff;
      }

      .priority-medium {
        background: #ffaa00;
        color: #000;
      }

      .priority-low {
        background: #00aa00;
        color: #fff;
      }

      .suggestion-code {
        position: relative;
        margin: 4px 0;
      }

      .suggestion-code pre {
        background: #0a0a0a;
        padding: 8px;
        border-radius: 2px;
        overflow-x: auto;
      }

      .copy-btn {
        position: absolute;
        top: 4px;
        right: 4px;
        background: #333;
        border: none;
        color: #fff;
        padding: 2px 6px;
        cursor: pointer;
        border-radius: 2px;
      }

      /* Related Items */
      .devtools-related-item {
        margin: 8px 0;
        padding: 8px;
        background: rgba(255, 255, 255, 0.05);
        border-left: 3px solid #888;
        border-radius: 2px;
        cursor: pointer;
      }

      .devtools-related-item:hover {
        background: rgba(255, 255, 255, 0.1);
      }

      .related-header {
        display: flex;
        justify-content: space-between;
        margin-bottom: 4px;
      }

      .related-relationship {
        font-weight: bold;
        color: #888;
        text-transform: capitalize;
      }

      .related-confidence {
        font-size: 10px;
        color: #4fc3f7;
      }

      .related-message {
        color: #ccc;
        margin: 2px 0;
      }

      .related-time {
        font-size: 10px;
        color: #666;
      }

      /* Settings Window Styles */
      .settings-tabs {
        display: flex;
        background: #2a2a2a;
        border-bottom: 1px solid #444;
      }

      .settings-tab {
        background: transparent;
        border: none;
        color: #888;
        padding: 12px 20px;
        cursor: pointer;
        border-bottom: 2px solid transparent;
        transition: all 0.2s;
      }

      .settings-tab:hover {
        color: #fff;
        background: rgba(255, 255, 255, 0.05);
      }

      .settings-tab.active {
        color: #4fc3f7;
        border-bottom-color: #4fc3f7;
      }

      .settings-content {
        padding: 20px;
      }

      .tab-content {
        display: none;
      }

      .tab-content.active {
        display: block;
      }

      .settings-section h3 {
        color: #4fc3f7;
        margin-bottom: 16px;
        border-bottom: 1px solid #333;
        padding-bottom: 8px;
      }

      /* Theme Grid */
      .theme-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
        gap: 16px;
        margin-bottom: 20px;
      }

      .theme-card {
        border: 2px solid #333;
        border-radius: 8px;
        padding: 12px;
        cursor: pointer;
        transition: all 0.2s;
        position: relative;
      }

      .theme-card:hover {
        border-color: #555;
      }

      .theme-card.active {
        border-color: #4fc3f7;
        box-shadow: 0 0 10px rgba(79, 195, 247, 0.3);
      }

      .theme-preview {
        height: 80px;
        border-radius: 4px;
        margin-bottom: 8px;
        overflow: hidden;
      }

      .preview-header {
        padding: 4px 8px;
        font-size: 10px;
        font-weight: bold;
      }

      .preview-content {
        padding: 8px;
        display: flex;
        gap: 8px;
        font-size: 10px;
      }

      .theme-name {
        font-weight: bold;
        text-align: center;
      }

      .theme-badge {
        position: absolute;
        top: 4px;
        right: 4px;
        background: #ff6b6b;
        color: #fff;
        padding: 2px 6px;
        border-radius: 10px;
        font-size: 8px;
      }

      /* Layout Grid */
      .layout-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
        gap: 16px;
        margin-bottom: 20px;
      }

      .layout-card {
        border: 2px solid #333;
        border-radius: 8px;
        padding: 12px;
        cursor: pointer;
        transition: all 0.2s;
        text-align: center;
      }

      .layout-card:hover {
        border-color: #555;
      }

      .layout-card.active {
        border-color: #4fc3f7;
        box-shadow: 0 0 10px rgba(79, 195, 247, 0.3);
      }

      .layout-preview {
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 8px;
      }

      .layout-preview svg {
        color: #4fc3f7;
      }

      .layout-name {
        font-weight: bold;
        margin-bottom: 4px;
      }

      .layout-description {
        font-size: 10px;
        color: #888;
      }

      /* Service Styles */
      .service-status {
        margin-bottom: 24px;
      }

      .service-item {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 8px 12px;
        border: 1px solid #333;
        border-radius: 4px;
        margin-bottom: 8px;
      }

      .service-name {
        flex: 1;
        font-weight: bold;
      }

      .service-status-badge {
        padding: 2px 8px;
        border-radius: 10px;
        font-size: 10px;
        text-transform: uppercase;
      }

      .service-status-badge.connected {
        background: #00aa00;
        color: #fff;
      }

      .service-status-badge.disconnected {
        background: #666;
        color: #fff;
      }

      .service-status-badge.error {
        background: #ff6b6b;
        color: #fff;
      }

      .service-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
        gap: 16px;
        margin-bottom: 20px;
      }

      .service-card {
        border: 1px solid #333;
        border-radius: 8px;
        padding: 16px;
      }

      .service-header h5 {
        margin: 0 0 8px 0;
        color: #4fc3f7;
      }

      .service-description {
        font-size: 12px;
        color: #888;
        margin-bottom: 12px;
      }

      /* Form Styles */
      .service-form {
        max-width: 100%;
      }

      .form-group {
        margin-bottom: 16px;
      }

      .form-group label {
        display: block;
        margin-bottom: 4px;
        color: #ccc;
        font-size: 12px;
      }

      .form-group input {
        width: 100%;
        padding: 8px;
        background: #1a1a1a;
        border: 1px solid #333;
        border-radius: 4px;
        color: #fff;
        font-family: inherit;
      }

      .form-group input:focus {
        outline: none;
        border-color: #4fc3f7;
      }

      .form-actions {
        display: flex;
        gap: 8px;
        justify-content: flex-end;
        margin-top: 20px;
      }

      .webhook-form {
        display: flex;
        gap: 8px;
        align-items: center;
      }

      .webhook-form input {
        flex: 1;
        padding: 6px;
        background: #1a1a1a;
        border: 1px solid #333;
        border-radius: 4px;
        color: #fff;
      }

      /* General Settings */
      .setting-group {
        margin-bottom: 16px;
        display: flex;
        align-items: center;
        gap: 8px;
      }

      .setting-group label {
        color: #ccc;
        cursor: pointer;
      }

      .setting-group input[type="checkbox"] {
        margin-right: 8px;
      }

      .setting-group input[type="number"],
      .setting-group input[type="range"] {
        background: #1a1a1a;
        border: 1px solid #333;
        border-radius: 4px;
        color: #fff;
        padding: 4px 8px;
      }

      .setting-actions {
        margin-top: 24px;
        display: flex;
        gap: 8px;
      }

      .theme-actions {
        display: flex;
        gap: 8px;
        margin-top: 16px;
      }
    `;
    
    document.head.appendChild(style);
    this.styleSheet = style;
  }

  updateOperations(operation) {
    // Real-time updates would be handled here
    // Avoid console.log to prevent infinite loops with error capture
  }

  destroy() {
    if (this.styleSheet) {
      this.styleSheet.remove();
    }
  }
}